import styled from 'styled-components'
import { rem } from 'polished'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import MerchandiseMegaMenuPanel from './MerchandiseMegaMenuPanel'
import { getMerchandiseCategoryUrl, getMerchandiseCategorySearchUrl, MIN_SUBCATEGORIES } from '../../merchandiseUtils'
import { merchandiseMegaMenuBreakpoints } from './merchandiseMegaMenuBreakpoints'
import { useMegaMenuTracking } from 'analytics/snowplow/events/megaMenuEvents'

const Container = styled(MerchandiseMegaMenuPanel)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  padding: ${rem(24)};

  ${merchandiseMegaMenuBreakpoints.mediumLarge} {
    padding: ${rem(24)};
  }
`

const StyledClickableListItem = styled(ClickableListItem)`
  && {
    padding-block: ${rem(8)};
    padding-inline: ${rem(12)};
  }
`

interface Props {
  categories: Array<App.MerchandiseCategory>
  onCategoryHover: (categoryId: string) => void
  onClose: () => void
}

function MerchandiseMegaMenuCategoryList(props: Props) {
  const { categories, onCategoryHover, onClose } = props
  const trackCategoryClick = useMegaMenuTracking('category', onClose)

  return <Container>
    {categories.map((category, index) => {
      const hasSubcategories = category.childCategoryIds.length >= MIN_SUBCATEGORIES
      const categoryUrl = hasSubcategories
        ? getMerchandiseCategoryUrl(category)
        : getMerchandiseCategorySearchUrl(category)

      return (
        <StyledClickableListItem
          key={category.id}
          to={categoryUrl}
          title={category.name}
          titleColour="normal-contrast"
          endIcon={hasSubcategories ? <LineAngleRightIcon size={20} colour="normal-contrast" /> : undefined}
          size="medium"
          onMouseEnter={() => onCategoryHover(category.id)}
          onClick={() => trackCategoryClick(category, index)}
        />
      )
    })}
  </Container>
}

export default MerchandiseMegaMenuCategoryList
